import { PROD_URL } from "api/config";

const URL_NEW_USER_PROFILE = `${PROD_URL}/users-profile`;
const URL_UPDATE_USER_PROFILE = (slug: string) => `${PROD_URL}/users-profile/${slug}`;

export { URL_NEW_USER_PROFILE, URL_UPDATE_USER_PROFILE };
